"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SulphuricImport = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var constants_1 = require("../../../constants");
var PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../../turmoil/parties/PartyName");
var CardRenderer_1 = require("../../render/CardRenderer");
var SelectOption_1 = require("../../../inputs/SelectOption");
var OrOptions_1 = require("../../../inputs/OrOptions");
var ResourceType_1 = require("../../../ResourceType");
var RemoveResourcesFromCard_1 = require("../../../deferredActions/RemoveResourcesFromCard");
var RemoveAnyPlants_1 = require("../../../deferredActions/RemoveAnyPlants");
var SulphuricImport = (function (_super) {
    __extends(SulphuricImport, _super);
    function SulphuricImport() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SULPHURIC_IMPORT,
            tags: [Tags_1.Tags.SPACE],
            cost: 11,
            metadata: {
                description: 'Raise Venus 1 step OR raise temperature 1 step. Remove up to 3 plants, 3 microbes or 2 animals from ANOTHER CARD owned by ANY player.',
                cardNumber: 'L413',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.venus(1).or().temperature(1).br;
                    b.minus().plants(-3).digit.slash().microbes(3).digit.any.asterix().slash().animals(2).digit.any.asterix();
                }),
            },
        }) || this;
    }
    SulphuricImport.prototype.canPlay = function (player) {
        var temperatureSteps = player.game.getTemperature() < constants_1.MAX_TEMPERATURE ? 1 : 0;
        var venusMaxed = player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE ? 1 : 0;
        var totalSteps = Math.max(temperatureSteps, venusMaxed);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + totalSteps * constants_1.REDS_RULING_POLICY_COST, { titanium: true });
        }
        return true;
    };
    SulphuricImport.prototype.play = function (player) {
        var game = player.game;
        var availableMicrobeCards = RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, ResourceType_1.ResourceType.MICROBE);
        var availableAnimalCards = RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, ResourceType_1.ResourceType.ANIMAL);
        var temperatureSteps = player.game.getTemperature() < constants_1.MAX_TEMPERATURE ? 1 : 0;
        var venusSteps = player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE ? 1 : 0;
        var totalSteps = temperatureSteps + venusSteps;
        var removePlants = function () {
            player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 3));
            return undefined;
        };
        var availableRemovalActions = [];
        var removePlantsOption = new SelectOption_1.SelectOption('Remove 3 plants', 'Remove plants', removePlants);
        availableRemovalActions.push(removePlantsOption);
        if (availableMicrobeCards.length > 0) {
            availableRemovalActions.push(new SelectOption_1.SelectOption('Remove 3 microbes from a card', 'Remove microbes', function () {
                player.game.defer(new RemoveResourcesFromCard_1.RemoveResourcesFromCard(player, ResourceType_1.ResourceType.MICROBE, 3));
                return undefined;
            }));
        }
        if (availableAnimalCards.length > 0) {
            availableRemovalActions.push(new SelectOption_1.SelectOption('Remove 2 animals from a card', 'Remove animals', function () {
                player.game.defer(new RemoveResourcesFromCard_1.RemoveResourcesFromCard(player, ResourceType_1.ResourceType.ANIMAL, 2));
                return undefined;
            }));
        }
        var increaseTemp = new SelectOption_1.SelectOption('Raise temperature 1 step', 'Raise temperature', function () {
            game.increaseTemperature(player, 1);
            player.game.log('${0} increased Temperature 1 step', function (b) { return b.player(player); });
            return new (OrOptions_1.OrOptions.bind.apply(OrOptions_1.OrOptions, __spreadArray([void 0], availableRemovalActions)))();
        });
        var increaseVenus = new SelectOption_1.SelectOption('Raise Venus 1 step', 'Raise venus', function () {
            game.increaseVenusScaleLevel(player, 1);
            player.game.log('${0} increased Venus 1 step', function (b) { return b.player(player); });
            return new (OrOptions_1.OrOptions.bind.apply(OrOptions_1.OrOptions, __spreadArray([void 0], availableRemovalActions)))();
        });
        var increaseTempOrVenus = new OrOptions_1.OrOptions(increaseTemp, increaseVenus);
        increaseTempOrVenus.title = 'Choose global parameter to raise';
        switch (totalSteps) {
            case 0:
                return new (OrOptions_1.OrOptions.bind.apply(OrOptions_1.OrOptions, __spreadArray([void 0], availableRemovalActions)))();
            case 1:
                if (temperatureSteps === 0) {
                    game.increaseVenusScaleLevel(player, 1);
                    player.game.log('${0} increased Venus 1 step', function (b) { return b.player(player); });
                }
                else {
                    game.increaseTemperature(player, 1);
                    player.game.log('${0} increased Temperature 1 step', function (b) { return b.player(player); });
                }
                return new (OrOptions_1.OrOptions.bind.apply(OrOptions_1.OrOptions, __spreadArray([void 0], availableRemovalActions)))();
            default:
                return increaseTempOrVenus;
        }
    };
    return SulphuricImport;
}(Card_1.Card));
exports.SulphuricImport = SulphuricImport;
//# sourceMappingURL=SulphuricImport.js.map